import * as React from "react";
import {Form, Row, Col, ListGroup, Button, Card} from "react-bootstrap";
import {Formik}  from "formik";
import * as Yup from "yup";
import withRequestState from "../../../components/WithRequestState";
import {connect} from "react-redux";
import {createProject, CREATE_PROJECT_REQUEST} from "../../../redux/projects/action";
import { RequestStateProps } from "../../../interfaces/RequestState";
import {Link, RouteComponentProps, withRouter} from "react-router-dom";
import { State } from "../../../interfaces/State";
import { Project } from "../../../interfaces/Project";
import * as Moment from "moment";
import "./index.scss";
import MainSettings from "./steps/mainSettings";
import ProjectLocation from "./steps/projectLocation";
import AssignUsers from "./steps/assignUsers";
import ProjectZones from "./steps/projectZones";
import AddEquipment from "./steps/addEquipment";
import { Contractor } from "../../../interfaces/Contractors";
import CreateContractor from "../../../modals/createContractor";
import {getContractors, createContractor} from "../../../redux/contractors/actions";
import {resetRequestState} from "../../../redux/requests/action";
import { CREATE_CONTRACTOR_REQUEST } from "../../../redux/contractors/reducer";

interface IProps {
    createProject: (name : string, description, startDate, endDate, projectType) => void;
    projects: Project[];
    contractors: Contractor[];
    getContractors: () => void;
    newContractor: () => void;
    createContractor: (contractorName: string, contractorDescription: string, contractorFirstName: string, contractorLastName: string, contractorMobileNumber: string, contractorWorkPhone: string, contractorEmail: string) => void;
    resetRequestState: (types?: string[]) => void;
}

interface IState {
    stage: number;
    newContractor: boolean;
    selectedContractors: Contractor[];
}

class NewProject extends React.Component<IProps & RouteComponentProps & RequestStateProps, IState> {

    constructor(props){
        super(props);
        this.state = {
            stage: 1,
            newContractor: false,
            selectedContractors: []
        }
    }

    componentDidMount(){
        this.props.getContractors();
    }

    componentDidUpdate(){
        if (this.props.requests[0].success){
            const project : Project = this.props.projects[this.props.projects.length - 1];
            this.props.history.push(`/projects/${project.id}`);
        }

        if (this.props.requests[1].success){
            this.setState({newContractor: false});
            this.props.resetRequestState();
        }
    }

    getStage(props) {
        switch (this.state.stage){
            case 1:
            default:
                return <MainSettings props={props} />
            case 2:
                return <ProjectLocation props={props} />
            case 3:
                return <ProjectZones props={props} />
            case 4:
                return <AssignUsers 
                    props={props} 
                    contractors={this.props.contractors} 
                    newContractor={() => this.setState({newContractor: true})} 
                    selectedContractors={this.state.selectedContractors}
                    selectContractor={contractor => this.addContractor(contractor)}
                    removeContractor={contractor => this.removeContractor(contractor)}
                />
            case 5:
                return <AddEquipment props={props} />
        }
    }


    addContractor(contractor : Contractor){
        const {selectedContractors} = this.state;
        selectedContractors.push(contractor);
        this.setState({selectedContractors});
    }

    removeContractor(contractor : Contractor){
        const {selectedContractors} = this.state;
        this.setState({
            selectedContractors: selectedContractors.filter(con => con.id != contractor.id)
        });
    }


    render(){
        return (
            <div className="p-4" id="create-project-page">
                <h2>CREATE A NEW PROJECT</h2>
                <Row>
                    <Col md={8} xs={12}>
                        <Card className="mt-4">                                    
                            <Formik
                                initialValues={{
                                    projectName: "",
                                    startDate: "",
                                    endDate: "",
                                    projectType: ""
                                }}
                                onSubmit={({projectName, startDate, endDate, projectType}) => {
                                    if (this.state.stage < 5){
                                        this.setState({
                                            stage: this.state.stage + 1
                                        }) 
                                    } else {
                                        this.props.createProject(projectName, null, Moment(startDate).toISOString(), Moment(endDate).toISOString(), projectType);
                                    }
                                }}
                                validationSchema={Yup.object().shape({
                                    projectName: Yup.string().min(1).required(),
                                    endDate: Yup.string(),
                                    startDate: Yup.string(),
                                    projectType: Yup.string()
                                })}
                            >
                                {(props) => (
                                    <Form onSubmit={props.handleSubmit} noValidate={true} className="mb-0">
                                        <Card.Body> 
                                            <Row>
                                                <Col md={3}>
                                                    <div className="steps wrapper">
                                                        <div>
                                                            <ul>
                                                                <li className={this.state.stage > 1 ? "completed" : ""}><p>Project main settings</p></li>
                                                                <li className={this.state.stage > 2 ? "completed" : ""}><p>Add project location</p></li>
                                                                <li className={this.state.stage > 3 ? "completed" : ""}><p>Set project sites</p></li>
                                                                <li className={this.state.stage > 4 ? "completed" : ""}><p>Assign contactors</p></li>
                                                                <li className={this.state.stage > 5 ? "completed" : ""}><p>Add equipment</p></li>
                                                            </ul>                                               
                                                        </div>
                                                        <span className="step-line" />
                                                        <span className={`step-counter stage-${this.state.stage}`}>{this.state.stage}</span>
                                                    </div>
                                                </Col>
                                                <Col md={9}>
                                                    {this.getStage(props)}                                            
                                                </Col>
                                            </Row>
                                        </Card.Body>

                                        <Card.Footer>
                                            <div>
                                                <Row>
                                                    <Col>
                                                        <Link to="/projects">
                                                            <Button variant="outline-primary">Cancel</Button>
                                                        </Link>
                                                        {
                                                            this.state.stage > 1 ? 
                                                                <Button onClick={() => this.setState({stage: this.state.stage-1})}>Back</Button> : null
                                                        }
                                                        
                                                    </Col>
                                                    <Col className="text-right">
                                                        <Button type="submit">{this.state.stage == 5 ? "Submit" : "Next"}</Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Card.Footer>                                
                                    </Form>
                                )}                            
                            </Formik> 
                        </Card>  
                    </Col>
                </Row>    
                <CreateContractor 
                    isOpen={this.state.newContractor} 
                    handleClose={() => this.setState({newContractor: false})}
                    handleSubmit={this.props.createContractor} 
                />                                
            </div>
        )
    }
}



export default withRouter(connect(
    (state : State) => ({
        projects: state.projects,
        contractors: state.contractors
    }),
    ({
        createProject,
        getContractors,
        createContractor,
        resetRequestState
    })
)(withRequestState(NewProject, [CREATE_PROJECT_REQUEST, CREATE_CONTRACTOR_REQUEST])));